import numberUtils from 'app/shared/utils/numberUtils';

interface Facts {
  medianRent?: number;
  diffFromLastMonth?: number;
  [key: string]: any; // To allow for other potential properties
}

interface Highlight {
  label: string;
  value: string;
}

export const useHighlights = (facts: Facts = {}): { parsedHighlights: Array<Highlight> } => {
  const parsedHighlights: Array<Highlight> = [];

  if (facts.medianRent) {
    parsedHighlights.push({
      label: 'Median rent',
      value: `${numberUtils.asCurrency(facts.medianRent)}`,
    });
  }

  if (facts.diffFromLastMonth) {
    parsedHighlights.push({
      label: 'Median rent, monthly change',
      value: `${facts.diffFromLastMonth.toFixed(2)}%`,
    });
  }

  return { parsedHighlights };
};
